module.exports = __webpack_public_path__ + "img/2-6.1a99e0e6.png";